__webpack_require__.p = "/rasheed/";